import { WidgetVersionController } from 'widgets/WidgetVersionManager/WidgetVersionManager.types';

// the latest version of the widget
export const VERSION = 3;

export class UpgradeV2 {
  version = 2;
  upgrade() {
    // deprecated - see changelog.md
  }
}

export class UpgradeV3 {
  version = 3;
  upgrade() {
    // deprecated - see changelog.md
  }
}

// Add VersionControllers here that implement the WidgetVersionController interface
export const statChartWidgetVersionControllers: WidgetVersionController[] = [new UpgradeV2(), new UpgradeV3()];
